export default (function (siteVars) {
  return {
    zIndex: 1000
  };
});